<script setup lang="ts">
import '@/assets/scss/dashboard.scss'
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { computed, onMounted, ref, watch } from 'vue'
import DashMenu from '@/onenetwork/layouts/components/menu/DashMenu.vue'
import { useOneNetworkMenuStore } from '@/onenetwork/stores/onenetwork.store.menu.ts'
import logo from '@/assets/images/onenetwork_logo_bo.svg'
import { useRoute, useRouter } from 'vue-router'
import { memberShipPlanStore } from '../../modules/setting/stores/onenetwork.store.memberShip.ts'

const route = useRoute()

const MenuStore = useOneNetworkMenuStore()
const MembershipPlanStore = memberShipPlanStore()
const props = defineProps({
  pageTitle: {
    type: String,
    default: 'Dashboard',
  },
  class: {
    type: String,
    default: '',
  },
  currentRoute: {
    type: String,
    default: '',
  },
  tabs: {
    type: Array,
    default: [],
  },
  tabsEvent: {
    type: Object,
    required: false,
  },
})

const currentRoute = computed(() => {
  return props.currentRoute.split('.')
})

const router = useRouter()

const openMenu = computed(() => {
  return MenuStore.openMenu
})

onMounted(() => {
  document.title = props.pageTitle
  MembershipPlanStore.fetchMembershipPlan()
})

watch(currentRoute, (newValue) => {}, { immediate: true })

const goToOverview = () => {
  router.push({ name: 'dashboard' })
}
</script>

<template>
  <template v-if="route.meta?.blankLayout">
    <slot></slot>
  </template>
  <div :class="`dashboard ${props.class || ''} ${openMenu ? 'open-menu' : ''}`" v-else>
    <aside>
      <div class="dash-logo cursor-pointer" @click="goToOverview">
        <img :src="logo" alt="Logo" />
      </div>
      <PerfectScrollbar>
        <div class="dashboard__menu">
          <dash-menu :currentRoute="currentRoute" />
        </div>
      </PerfectScrollbar>
    </aside>
    <main>
      <slot></slot>
    </main>
  </div>
</template>

<style scoped></style>
